import { Box, Typography } from "@mui/material";
import { noteCardSx } from "./cards.style";
import { formattedDate } from "../../utils/dateUtils";
import { typeColor } from "../../styles/commonStyles";

const FieldNoteCard = ({
  note_type,
  date,
  description,
  href,
  title,
  onClick,
}) => {
  const type =
    note_type === "DISEASE_REPORT" ? "Segnalazione malattia" : "Nota";
  const maxLength = 70;
  const shortDescription =
    description.length > maxLength
      ? description.slice(0, maxLength) + "..."
      : description;

  return (
    <Box
      onClick={onClick}
      sx={{
        ...noteCardSx.root,
        width: "100%",
        height: 172,
      }}
    >
      {/* Header */}
      <Box sx={noteCardSx.header}>
        <Typography sx={noteCardSx.title}>{title}</Typography>
        <Typography sx={{ ...noteCardSx.type, color: typeColor[note_type] }}>
          {type}
        </Typography>
      </Box>
      {/* Content */}
      <Box sx={noteCardSx.content}>
        <Typography sx={noteCardSx.date}>
          {formattedDate(date, true)}
        </Typography>
        <Typography sx={noteCardSx.description}>{shortDescription}</Typography>
      </Box>
      {/* Footer */}
      <Box sx={noteCardSx.footer}>
        <Typography sx={noteCardSx.button} href={href}>
          Vedi
        </Typography>
      </Box>
    </Box>
  );
};

export default FieldNoteCard;
